import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import theme from "../../Styles/theme.scss";
import React, { MouseEventHandler } from "react";

interface SecondaryButtonProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const SecondaryButtonStyled = styled(Button)(() => ({
  color: theme.primary6,
  textTransform: "none",
  textDecoration: "underline",
  "& .MuiButton-startIcon": { marginRight: 4, marginBottom: 3 },
  "& .MuiButton-endIcon": { marginLeft: 4, marginBottom: 3 },
  "&:disabled": {
    color: theme.neutral4,
    backgroundColor: theme.neutral7,
  },
}));

const SecondaryButton = ({
  children,
  style,
  className,
  endIcon,
  startIcon,
  onClick,
  disabled,
}: SecondaryButtonProps) => {
  return (
    <SecondaryButtonStyled
      className={className}
      style={style}
      endIcon={endIcon}
      startIcon={startIcon}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </SecondaryButtonStyled>
  );
};
export default SecondaryButton;
